
// ModalPesquisarFornecedor.js

import React, { useState } from 'react';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './ModalPesquisarCliente.css';

const ModalPesquisarFornecedor = ({ isOpen, onClose, onFornecedorSelecionado }) => {
  const [searchType, setSearchType] = useState('codigo');
  const [searchValue, setSearchValue] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSearch = async () => {
    let url = `/fornecedores/buscarfornecedor`;
    let params = {};

    if (searchType === 'codigo') {
      params = { codfor: searchValue };
    } else if (searchType === 'nome') {
      params = { nomefor: searchValue };
    } else if (searchType === 'cnpj') {
      // eslint-disable-next-line no-unused-vars
      params = { cnpjfor: searchValue };
    }

    try {

    //const response = await axios.get(url, { params });

    // Realizando a requisição GET com parâmetros e cabeçalhos
      const response = await api.get(url);

      if (response.data && response.data.length > 0) {
        const fornecedor = response.data[0];
        setSearchResult(fornecedor);
        setErrorMessage('');
      } else {
        setSearchResult(null);
        setErrorMessage('Fornecedor não Encontrado');
      }
    } catch (error) {
      console.error('Erro ao buscar fornecedor:', error);
      setSearchResult(null);
      setErrorMessage('Erro ao buscar fornecedor: ' + error.message);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleConfirmar = () => {
    if (searchResult) {
      onFornecedorSelecionado(searchResult);
      onClose();
    }
  };

  return (
    isOpen && (
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={onClose}>&times;</span>
          <h3>Selecionar Fornecedor</h3>
          <div>
            <label>
              <input
                type="radio"
                value="codigo"
                checked={searchType === 'codigo'}
                onChange={() => setSearchType('codigo')}
              />
              Código
            </label>
            <label>
              <input
                type="radio"
                value="nome"
                checked={searchType === 'nome'}
                onChange={() => setSearchType('nome')}
              />
              Nome
            </label>
            <label>
              <input
                type="radio"
                value="cnpj"
                checked={searchType === 'cnpj'}
                onChange={() => setSearchType('cnpj')}
              />
              CNPJ
            </label>
          </div>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <div className="button-container">
            <button className="search-button" onClick={handleSearch}>Pesquisar</button>
          </div>
          {searchResult && (
            <div>
              <p>Fornecedor Encontrado: {searchResult.nomefor}</p>
              <div className="button-container">
                <button className="search-button" onClick={handleConfirmar}>Confirmar</button>
              </div>
            </div>
          )}
          {errorMessage && <p>{errorMessage}</p>}
        </div>
      </div>
    )
  );
}

export default ModalPesquisarFornecedor;